async function updateFrwdNtfFlag(url, options) {
    fetch(url, options).then((response) => {
        return response;
    });
}

export default updateFrwdNtfFlag;